module.exports = __webpack_public_path__ + "media/images/flags/lv-6fb1103d3f287395c7c5a9e3cd33c40a.svg";